import * as Tone from 'tone';
import AudioEffect from '../effects/audio/AudioEffect';
import Instrument from '../instruments/Instrument';
import Chain from './Chain';
import MidiNode from './MidiNode';
class MidiToAudioChain extends Chain {
    constructor() {
        super();
        this.inputNode = new MidiNode();
        this.outputNode = new Tone.Gain(0, "decibels");
        this.output().toDestination();
    }
    input() { return this.inputNode; }
    output() { return this.outputNode; }
    insert(device, position) {
        if (position === undefined) {
            position = this.devices.length;
        }
        if (device instanceof Instrument) {
            const index = this.indexOfInstrument();
            if (index >= 0) {
                throw Error('An instrument is already present');
            }
        }
        this.devices[position] = device;
        this.reconnect();
    }
    reconnect() {
        // disconnect chain
        this.input().disconnect();
        for (const device of this.devices) {
            device.output().disconnect();
        }
        if (this.devices.length === 0) {
            throw 'Cannot connect MidiToAudioChain without any devices';
        }
        const [firstDevice] = this.devices;
        if (firstDevice instanceof AudioEffect) {
            throw 'Cannot connect MidiToAudioChain directly to AudioEffect';
        }
        this.input().connect(firstDevice);
        for (let i = 0; i < this.devices.length; i++) {
            const device = this.devices[i];
            const nextDevice = this.devices[i + 1];
            if (nextDevice === undefined) {
                if (device instanceof AudioEffect || device instanceof Instrument) {
                    // device.connect(this.output())
                    // this.output().toDestination()
                    device.output().toDestination();
                }
                return;
            }
            if (device instanceof Instrument || device instanceof AudioEffect) {
                if (!(nextDevice instanceof AudioEffect)) {
                    throw 'Only AudioEffects can come after an Instrument or an AudioEffect';
                }
                device.output().connect(nextDevice.input());
            }
            else {
                if (nextDevice instanceof AudioEffect) {
                    throw 'An AudioEffect cannot come after a MidiEffect';
                }
                device.output().connect(nextDevice.input());
            }
        }
    }
    indexOfInstrument() {
        for (let i = 0; i < this.devices.length; i++) {
            if (this.devices[i] instanceof Instrument) {
                return i;
            }
        }
        return -1;
    }
}
export default MidiToAudioChain;
//# sourceMappingURL=MidiToAudioChain.js.map